
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogRT(): TemplateResult<dialogRTRootProps> {
    function onClick1(e) {
        window.Convermax.regoSearch(e);
    }
    function onClick2(e) {
        {
            window.Convermax.switchTabInSearchByVehicleDialog(e);
        }
    }
    function onClick3(e) {
        {
            window.Convermax.openGarageInDialog(e);
        }
    }
    function onClick4(e) {
        {
            window.Convermax.switchTabInSearchByVehicleDialog(e);
        }
    }
    function onClick5(e) {
        {
            window.Convermax.openGarageInDialog(e);
        }
    }
    function onClick6(e) {
        {
            window.Convermax.switchTabInSearchByVehicleDialog(e);
        }
    }
    function onClick7(e) {
        {
            window.Convermax.switchTabInSearchByVehicleDialog(e, 1);
        }
    }
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', { 'className': 'vehicle-search-modal__dialog' }, _createElement('header', { 'className': 'vehicle-search-modal__header' }, _createElement('h2', { 'className': 'vehicle-search-modal__title' }, 'Rego Search'), _createElement('button', {
        'onClick': this.close,
        'type': 'button',
        'className': 'vehicle-search-modal__close'
    }, [_createElement('svg', {
            'viewBox': '0 0 32.8672 32.8669',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '33',
            'height': '33',
            'fill': 'none',
            'aria-hidden': 'true',
            'focusable': 'false',
            'key': '2860'
        }, _createElement('path', {
            'd': 'M12.6202 10.6203L12.6202 1C12.6202 0.33332 12.2869 -0 11.6202 -0C10.9536 0 10.6202 0.33332 10.6202 1L10.6202 10.6203L1 10.6203C0.33332 10.6203 0 10.9536 0 11.6203C0 12.2869 0.33332 12.6203 1 12.6203L10.6202 12.6203L10.6202 22.2405C10.6202 22.9071 10.9536 23.2405 11.6202 23.2405C12.2869 23.2405 12.6202 22.9071 12.6202 22.2405L12.6202 12.6203L22.2405 12.6203C22.9071 12.6203 23.2405 12.2869 23.2405 11.6203C23.2405 10.9536 22.9071 10.6203 22.2405 10.6203L12.6202 10.6203Z',
            'fill': 'rgb(32,43,76)',
            'fillRule': 'evenodd',
            'transform': 'matrix(0.707107,-0.707107,0.707107,0.707107,0,16.4335)'
        }))])), _createElement('div', { 'className': 'vehicle-search-modal__panel vehicle-search-modal__panel--active' }, _createElement('div', { 'className': 'vehicle-search-modal__body' }, _createElement('p', { 'className': 'vehicle-search-modal__step' }, _createElement('span', { 'className': 'vehicle-search-modal__step-label' }, 'Step 1.'), _createElement('span', { 'className': 'vehicle-search-modal__step-text' }, ' Do you know the rego plate?')), _createElement('div', { 'className': 'vehicle-search-modal__rego' }, _createElement('label', { 'className': 'vehicle-search-modal__rego-label' }, 'REGO'), _createElement('span', { 'className': 'vehicle-search-modal__rego-separator' }), _createElement('input', {
        'type': 'text',
        'className': 'vehicle-search-modal__rego-input',
        'placeholder': 'AAA-0000',
        'inputmode': 'text'
    })), _createElement('p', { 'className': 'vehicle-search-modal__step' }, _createElement('span', { 'className': 'vehicle-search-modal__step-label' }, 'Step 2.'), _createElement('span', { 'className': 'vehicle-search-modal__step-text' }, ' Enter your state:')), _createElement('div', { 'className': 'vehicle-search-modal__select' }, _createElement('label', {
        'className': 'visually-hidden',
        'htmlFor': 'vehicle-search-state'
    }, 'Select state'), _createElement('select', { 'className': 'vehicle-search-modal__select-input' }, [
        _createElement('option', {
            'value': true,
            'selected': true,
            'disabled': true,
            'key': '21760'
        }, 'Select State'),
        _createElement('option', {
            'value': 'NSW',
            'key': '21762'
        }, 'NSW'),
        _createElement('option', {
            'value': 'VIC',
            'key': '21764'
        }, 'VIC'),
        _createElement('option', {
            'value': 'QLD',
            'key': '21766'
        }, 'QLD'),
        _createElement('option', {
            'value': 'WA',
            'key': '21768'
        }, 'WA'),
        _createElement('option', {
            'value': 'SA',
            'key': '217610'
        }, 'SA'),
        _createElement('option', {
            'value': 'TAS',
            'key': '217612'
        }, 'TAS'),
        _createElement('option', {
            'value': 'ACT',
            'key': '217614'
        }, 'ACT'),
        _createElement('option', {
            'value': 'NT',
            'key': '217616'
        }, 'NT')
    ]), _createElement('span', { 'className': 'vehicle-search-modal__select-icon' }, [_createElement('svg', {
            'width': '14',
            'height': '14',
            'viewBox': '0 0 14 14',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '26140'
        }, _createElement('path', {
            'd': 'M11 5.5L7 9.5L3 5.5',
            'stroke': 'currentColor',
            'strokeWidth': 'var(--icon-stroke-width)',
            'strokeLinecap': 'round',
            'strokeLinejoin': 'round'
        }))])), _createElement('button', {
        'onClick': onClick1.bind(this),
        'type': 'button',
        'className': 'vehicle-search-modal__search-button'
    }, '\n          SEARCH\n        '), _createElement('div', { 'className': 'vehicle-search-modal__divider' }, _createElement('span', { 'className': 'vehicle-search-modal__divider-line' }), _createElement('span', { 'className': 'vehicle-search-modal__divider-text' }, 'OR'), _createElement('span', { 'className': 'vehicle-search-modal__divider-line' })), _createElement('button', {
        'onClick': onClick2.bind(this),
        'type': 'button',
        'className': 'vehicle-search-modal__manual'
    }, _createElement('span', { 'className': 'vehicle-search-modal__manual-text' }, 'Manual Vehicle Search'), _createElement('span', { 'className': 'vehicle-search-modal__manual-icon' }, [_createElement('svg', {
            'viewBox': '0 0 7.47461 12.1213',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '8',
            'height': '12',
            'fill': 'none',
            'focusable': 'false',
            'key': '36360'
        }, _createElement('path', {
            'd': 'M0 0L5 5L10 0',
            'stroke': 'rgb(32,43,76)',
            'strokeLinecap': 'round',
            'strokeWidth': '2',
            'transform': 'matrix(0,-1,1,0,1.06055,11.0607)'
        }))])), _createElement('button', {
        'onClick': onClick3.bind(this),
        'type': 'button',
        'className': 'vehicle-search-modal__manual'
    }, _createElement('span', { 'className': 'vehicle-search-modal__manual-text' }, 'My Garage'), _createElement('span', { 'className': 'vehicle-search-modal__manual-icon' }, [_createElement('svg', {
            'viewBox': '0 0 7.47461 12.1213',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '8',
            'height': '12',
            'fill': 'none',
            'focusable': 'false',
            'key': '42370'
        }, _createElement('path', {
            'd': 'M0 0L5 5L10 0',
            'stroke': 'rgb(32,43,76)',
            'strokeLinecap': 'round',
            'strokeWidth': '2',
            'transform': 'matrix(0,-1,1,0,1.06055,11.0607)'
        }))])))), _createElement('div', {
        'className': 'vehicle-search-modal__panel',
        'hidden': true
    }, _createElement('div', { 'className': 'vehicle-search-modal__body vehicle-search-modal__body--manual' }, [this.vehicleWidget(function () {
            function repeatSelects1(selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                        }
                        function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                isPopularField ? [
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-popular',
                                        'disabled': true,
                                        'key': '11021'
                                    }, _translate(`ymm_bar_popular`)),
                                    _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-unpopular',
                                        'disabled': true,
                                        'key': '11024'
                                    }, _translate(`ymm_bar_unpopular`))
                                ] : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        function scopeShowSelectedValues4() {
                            var showSelectedValues = this.selectedEntries.length;
                            return _createElement('option', {
                                'key': '_current',
                                'value': '_current'
                            }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                _translate(`select_title`),
                                ' ',
                                this.title
                            ] : null);
                        }
                        function repeatEntry5(entry, index) {
                            return _createElement('div', {
                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                'key': entry.value,
                                'onClick': () => this.onChange(entry.term)
                            }, this.showCheckboxes ? _createElement('input', {
                                'type': 'checkbox',
                                'readOnly': true,
                                'checked': entry.selected,
                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                'key': '3324'
                            }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                'className': 'cm_dropdown_hitCount',
                                'key': '3526'
                            }, entry.hitCount) : null);
                        }
                        return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                            'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                            'key': '39'
                        }, _createElement('select', {
                            'className': 'cm_select_inner-select cm_select__pretty',
                            'onChange': this.onChange,
                            'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                            'disabled': this.disabled,
                            'aria-label': this.title
                        }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                    return _createElement('div', { 'className': 'cm_filterInput' });
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                'aria-label': this.title,
                                'key': '2586'
                            },
                            !this.hideNullOption ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'onClick': () => this.onChange('')
                            }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                            this.loading ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'disabled': true
                            }, _translate(`select_loading`)) : null,
                            !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                        ]) : null);
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_DialogVehicleWidget_tab cm_vehicle-widget cm_vehicle-widget__dialog cm_vehicle-widget__rego-search cm_vehicleWidget' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                'div',
                { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                _map(this.selects, repeatSelects1.bind(this))
            ])), _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go cm_button cm_button__primary',
                'onClick': this.selectVehicle,
                'disabled': !this.allowToSetVehicle,
                'role': 'button',
                'tabIndex': this.allowToSetVehicle ? '0' : '-1'
            }, '\n              Search Vehicle\n            ')));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], _createElement('div', { 'className': 'vehicle-search-modal__divider' }, _createElement('span', { 'className': 'vehicle-search-modal__divider-line' }), _createElement('span', { 'className': 'vehicle-search-modal__divider-text' }, 'OR'), _createElement('span', { 'className': 'vehicle-search-modal__divider-line' })), _createElement('button', {
        'onClick': onClick4.bind(this),
        'type': 'button',
        'className': 'vehicle-search-modal__manual'
    }, _createElement('span', { 'className': 'vehicle-search-modal__manual-text' }, 'Search Via Rego'), _createElement('span', { 'className': 'vehicle-search-modal__manual-icon' }, [_createElement('svg', {
            'viewBox': '0 0 7.47461 12.1213',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '8',
            'height': '12',
            'fill': 'none',
            'focusable': 'false',
            'key': '120880'
        }, _createElement('path', {
            'd': 'M0 0L5 5L10 0',
            'stroke': 'rgb(32,43,76)',
            'strokeLinecap': 'round',
            'strokeWidth': '2',
            'transform': 'matrix(0,-1,1,0,1.06055,11.0607)'
        }))])), _createElement('button', {
        'onClick': onClick5.bind(this),
        'type': 'button',
        'className': 'vehicle-search-modal__manual'
    }, _createElement('span', { 'className': 'vehicle-search-modal__manual-text' }, 'My Garage'), _createElement('span', { 'className': 'vehicle-search-modal__manual-icon' }, [_createElement('svg', {
            'viewBox': '0 0 7.47461 12.1213',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '8',
            'height': '12',
            'fill': 'none',
            'focusable': 'false',
            'key': '126890'
        }, _createElement('path', {
            'd': 'M0 0L5 5L10 0',
            'stroke': 'rgb(32,43,76)',
            'strokeLinecap': 'round',
            'strokeWidth': '2',
            'transform': 'matrix(0,-1,1,0,1.06055,11.0607)'
        }))])))), _createElement('div', {
        'className': 'vehicle-search-modal__panel',
        'hidden': true
    }, _createElement('div', { 'className': 'vehicle-search-modal__body vehicle-search-modal__body--garage' }, [this.vehicleList(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', {
                            'className': 'dialog-body-garage-item' + (this.isSelected ? ' selected' : ''),
                            'onClick': this.selectVehicle
                        }, _createElement('div', { 'className': 'dialog-body-garage-content' }, _createElement('span', { 'className': 'dialog-body-garage-content-vehicle' }, '\n                              ', this.vehicleBaseValues.join(' '), '\n                            '), _createElement('span', { 'className': 'dialog-body-garage-content-info' }, '\n                              ', this.vehicleExtraValues.join(' '), '\n                            ')), _createElement('span', {
                            'className': 'dialog-body-garage-item-remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'className': 'cm_icon cm_icon-times',
                                'height': '20px',
                                'role': 'img',
                                'viewBox': '0 0 22 22',
                                'key': '7630'
                            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_GarageDialogContent cm_vehicleList' }, _createElement('div', { 'className': 'cm_garage cm_garage__dialog' }, _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'className': 'dialog-body' }, _createElement('div', { 'className': 'dialog-body-content' }, _createElement('div', { 'className': 'cm_garageDropdown' }, this.isEmpty ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '305'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null, !this.isEmpty ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '845'
            }, _createElement('div', { 'className': 'dialog-body-title' }, 'Search parts for:'), _createElement.apply(this, [
                'div',
                { 'className': 'dialog-body-content-with-vehicles cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), _createElement('div', { 'className': 'dialog-body-buttons-container' }, this.vehicle.Make && this.vehicle.Model ? _createElement('a', {
                'href': window.Convermax.getVehicleUrl(window.Convermax.Shopify.searchPageUrl),
                'className': 'dialog-body-shop-parts',
                'key': '2511'
            }, '\n                          Shop ', this.vehicle.Make, ' ', this.vehicle.Model, ' Parts\n                        ') : null, _createElement('a', {
                'href': window.Convermax.Shopify.collectionsUrl,
                'className': 'dialog-body-view-all-categories'
            }, '\n                          View all categories\n                        '), _createElement('button', {
                'onClick': this.close,
                'className': 'dialog-body-continue-shopping'
            }, '\n                          Continue Shopping\n                        '))) : null))))));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], _createElement('div', { 'className': 'vehicle-search-modal__divider' }, _createElement('span', { 'className': 'vehicle-search-modal__divider-line' }), _createElement('span', { 'className': 'vehicle-search-modal__divider-text' }, 'OR'), _createElement('span', { 'className': 'vehicle-search-modal__divider-line' })), _createElement('button', {
        'onClick': onClick6.bind(this),
        'type': 'button',
        'className': 'vehicle-search-modal__manual'
    }, _createElement('span', { 'className': 'vehicle-search-modal__manual-text' }, 'Search Via Rego'), _createElement('span', { 'className': 'vehicle-search-modal__manual-icon' }, [_createElement('svg', {
            'viewBox': '0 0 7.47461 12.1213',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '8',
            'height': '12',
            'fill': 'none',
            'focusable': 'false',
            'key': '178590'
        }, _createElement('path', {
            'd': 'M0 0L5 5L10 0',
            'stroke': 'rgb(32,43,76)',
            'strokeLinecap': 'round',
            'strokeWidth': '2',
            'transform': 'matrix(0,-1,1,0,1.06055,11.0607)'
        }))])), _createElement('button', {
        'onClick': onClick7.bind(this),
        'type': 'button',
        'className': 'vehicle-search-modal__manual'
    }, _createElement('span', { 'className': 'vehicle-search-modal__manual-text' }, 'Manual Vehicle Search'), _createElement('span', { 'className': 'vehicle-search-modal__manual-icon' }, [_createElement('svg', {
            'viewBox': '0 0 7.47461 12.1213',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '8',
            'height': '12',
            'fill': 'none',
            'focusable': 'false',
            'key': '184890'
        }, _createElement('path', {
            'd': 'M0 0L5 5L10 0',
            'stroke': 'rgb(32,43,76)',
            'strokeLinecap': 'round',
            'strokeWidth': '2',
            'transform': 'matrix(0,-1,1,0,1.06055,11.0607)'
        }))]))))));
}
        export const componentNames = ["cm:filterInput","cm:vehicleWidget","cm:vehicleList"]